import React from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import InputGroup from "../atoms/InputGroup";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { OrderAddUseContext } from "../../context/AdminDashboard/OrderAddContext";

export default function Calendar({ dateval, width }) {
  const { changedate } = OrderAddUseContext();

  // Render the DatePicker component with Persian calendar and time picker plugin
  return (
    <DatePicker
      format="YYYY/MM/DD HH:mm:ss"
      onChange={changedate}
      eachDaysInRange
      calendar={persian}
      locale={persian_fa}
      value={dateval}
      plugins={[<TimePicker position="bottom" />]}
      render={<CustomRangeInput width={width} />}
    />
  );
}

// CustomRangeInput component for rendering custom input for DatePicker
function CustomRangeInput({ openCalendar, value, width }) {
  return (
    <>
      <InputGroup
        placeholder="22 خرداد 1402"
        iconName={"calendar"}
        onFocus={openCalendar}
        label={"تاریخ ثبت سفارش"}
        value={value}
        readOnly={true}
        width={width}
      />
    </>
  );
}
